<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" disabled @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.specialtyId" placeholder="所属专业" disabled @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.agentId" placeholder="考级点" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in agentList" :key="index" :label="item.agentName" :value="item.agentId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeName" clearable placeholder="考生姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeIdNo" clearable placeholder="证件号"></el-input>
        <el-select v-model="queryParam.evaluateStatus" placeholder="评分状态" filterable clearable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.evaluateStatus2)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam))" type="default">重置</el-button>
      </div>
      <div class="text-right" style="margin-top: 10px;">
        <el-button v-if="this.$route.query.isOnline == 0" @click="downloadTemp()" type="primary" style="margin-right: 10px;">线下评分模板</el-button>
        <el-button v-if="this.$route.query.isOnline == 0" @click="exam()" type="primary" style="margin-right: 10px;">导入线下评分</el-button>
        <el-button @click="exportExcel()" type="primary" style="margin-right: 10px;">导出考生</el-button>
        <el-button @click="getExportExamLicense()" type="primary" style="margin-right: 10px;">导出准考证</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="multipleSelection=$event">
        <el-table-column prop="examineeName" label="姓名"></el-table-column>
        <el-table-column prop="agentName" label="考级点"></el-table-column>
        <el-table-column prop="categoryName" label="所属分类"></el-table-column>
        <el-table-column prop="specialtyName" label="所属专业">
          <template slot-scope="scope">
            {{scope.row.specialtyName}}-{{scope.row.gradeName}}
          </template>
        </el-table-column>
        <el-table-column prop="examineeIdNo" label="证件号"></el-table-column>
        <el-table-column prop="enrollTime" label="报名时间"></el-table-column>
        <el-table-column prop="evaluateStatus" label="状态">
          <template slot-scope="scope">
            {{$enums.evaluateStatus2[scope.row.evaluateStatus]}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="$router.push({path:'./video',query:{batchId:scope.row.batchId,roomId:scope.row.roomId,examId:scope.row.examId}})">
              查看视频
            </el-button>
            <el-button size="mini" type="text" @click="changeRoom(scope.row.evaluateExamId, scope.row.roomId, scope.row.batchId)">
              修改考场
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <p>当前导出进度进度</p>
      <div style="text-align: center">
        <el-progress type="circle" :percentage="percent"></el-progress>
      </div>
    </el-dialog>
    <el-dialog title="导入考生数据" v-if="examForm.show" :visible.sync="examForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Exam :row="examForm.row" @close="onClose"></Exam>
    </el-dialog>
    <el-dialog title="修改考场" v-if="changeForm.show" :visible.sync="changeForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Change :row="changeForm.row" :room="changeForm.room" :batch="changeForm.batch" @closeChange="onChangeClose"></Change>
    </el-dialog>
  </div>
</template>
<script>
import Exam from './exam-edit'
import Change from './exam-changeRoom'

export default {
  name: 'list',
  components: { Exam, Change },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId, roomId: this.$route.query.roomId, specialtyId: this.$route.query.specialtyId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      multipleSelection: [],
      editForm: { show: false, row: null },
      changeForm: { show: false, row: null },
      batchList: [],
      specialtyList: [],
      agentList: [],
      taskInterval: 0,
      dialogVisible: false,
      percent: null,
      examForm: { show: false, row: null }
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
    clearInterval(this.taskInterval)
  },
  computed: {},
  watch: {},
  methods: {
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      this.agentList = await this.$HTTP.ApiBatch.getAgentList(this.queryParam.batchId)
      if (event) {
        this.queryParam.specialtyId = ''
        this.queryParam.agentId = ''
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.row = null
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (newQueryParam.evaluateStatus || newQueryParam.evaluateStatus == 0) {
          newQueryParam.evaluateStatus = [newQueryParam.evaluateStatus]
        }
        if (queryParam && !queryParam.pageSize) {
          this.$set(queryParam, 'pageSize', this.page.pageSize)
        }
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        let page = await this.$HTTP.GradeExam.getEvaluateExamPage(newQueryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
    },
    async changeRoom (row, room, batch) {
      this.changeForm.show = true
      if (row) {
        this.changeForm.row = row
      } else {
        this.changeForm.row = null
      }
      if (room) {
        this.changeForm.room = room
      } else {
        this.changeForm.room = null
      }
      if (batch) {
        this.changeForm.batch = batch
      } else {
        this.changeForm.batch = null
      }
    },
    async exportExcel (row) {
      try {
        await this.$HTTP.GradeExam.exportExcel(this.queryParam)
        this.getTaskInfo('export_evaluate_exam')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async getExportExamLicense (row) {
      try {
        await this.$HTTP.GradeExam.getExportExamLicense(this.queryParam)
        this.getTaskInfo('export_exam_license')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async onClose (event) {
      try {
        this.getTaskInfo('import_evaluate_allot')
        this.examForm.show = false
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async onChangeClose () {
      try {
        this.changeForm.show = false
        await this.getPage()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    getTaskInfo (taskName) {
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.GradeCommon.getTaskInfo(taskName)
          this.percent = taskInfo.percent
          if (taskInfo) {
            this.dialogVisible = true
            if (taskInfo.errorExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.successExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'success', message: '操作成功' })
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
          }
          if (taskInfo.percent >= 100) {
            this.dialogVisible = false
          }
        } catch (e) {
          clearInterval(this.taskInterval)
        }
      }, 2000)
    },
    async exam (row) {
      this.examForm.show = true
      if (row) {
        this.examForm.row = row
      } else {
        this.examForm.row = null
      }
    },
    async downloadTemp () {
      let url = 'http://zego-davinci-public.oss-cn-shanghai.aliyuncs.com/dev/hbyx/import_model/allot_exam.xlsx'
      let fileUrl = await this.$HTTP.ApiOss.signatureUrl(url, 'public-read')
      this.Tool.downloadFile(fileUrl)
    }
  }
}
</script>
